import React, { useState, useEffect } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment'
import api from '../../api';
import { apiURL } from '../../config';
import _ from 'lodash';
import 'react-big-calendar/lib/sass/styles.scss';
import './AvailableDates.scss';


const AvailableDates = () => {
  const localizer = momentLocalizer(moment);
  const [jeevesBookings, setJeevesBookings] = useState([]);
  const [allBookings, setAllBookings] = useState([]);

  //useEffect to make api call to get jeeves bookings
  useEffect(() => {
    api
      .get(`${apiURL}calendar/jeeves`)
      .then((data) => { 
        setJeevesBookings(data.data) 
      });
  }, [])

  useEffect(() => {
    let temp = []
    _.map(jeevesBookings, (booking) => {
      return temp = [...temp, { title: 'Unavailable', start: moment(booking.DTSTART), end: moment(booking.DTEND) }]
    })
    setAllBookings((prev) => { return [...prev, ...temp] })
  }, [jeevesBookings])

  return (
    <div className="calendar">
      <h1>Available Dates</h1>
      <Calendar 
        localizer={localizer}
        views={["month"]}
        drilldownView={null}
        events={allBookings}
      />
    </div>
  );
}

export default AvailableDates;